module.exports = "/_next/static/images/attorney-mamari-eb934f9680dcff89e0ecd0cf07fcba1e.png";